var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.6663 36.6667H3.33301C2.64967 36.6667 2.08301 36.1001 2.08301 35.4167C2.08301 34.7334 2.64967 34.1667 3.33301 34.1667H36.6663C37.3497 34.1667 37.9163 34.7334 37.9163 35.4167C37.9163 36.1001 37.3497 36.6667 36.6663 36.6667Z",
    fill: "#8E99A7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 6.66659V36.6666H23.75V6.66659C23.75 4.83325 23 3.33325 20.75 3.33325H19.25C17 3.33325 16.25 4.83325 16.25 6.66659Z",
    fill: "#8E99A7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 16.6666V36.6666H11.6667V16.6666C11.6667 14.8333 11 13.3333 9 13.3333H7.66667C5.66667 13.3333 5 14.8333 5 16.6666Z",
    fill: "#8E99A7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.333 25.0001V36.6667H34.9997V25.0001C34.9997 23.1667 34.333 21.6667 32.333 21.6667H30.9997C28.9997 21.6667 28.333 23.1667 28.333 25.0001Z",
    fill: "#8E99A7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/chart.5057f2201a2a3a2a057db6ce6a38d42b.svg";
export { ForwardRef as ReactComponent };